export enum InputTypeEnum {
  Date,
  PhoneNumber,
  Select
}
